import { render, staticRenderFns } from "./ReviewAll.vue?vue&type=template&id=2ac21f96&scoped=true"
import script from "./ReviewAll.vue?vue&type=script&lang=js"
export * from "./ReviewAll.vue?vue&type=script&lang=js"
import style1 from "./ReviewAll.vue?vue&type=style&index=1&id=2ac21f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac21f96",
  null
  
)

export default component.exports